import React from "react";
import { Loader2, Menu, RefreshCw, Search, SlidersHorizontal, Users, X } from "lucide-react";
import { useAdminLayout } from "../AdminLayoutContext";

export default function AdminUsersChrome({
  search,
  onSearchChange,
  loading,
  onRefresh,
  filtersOpen,
  onFiltersToggle,
  activeFilterCount,
  totalUsers,
  activeCount,
  bannedCount,
}) {
  const { openMobileMenu } = useAdminLayout();

  return (
    <>
      <header className="am-chrome">
        <div className="am-chrome-row">
          <div className="am-chrome-lead">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon lg:hidden"
              onClick={openMobileMenu}
              aria-label="Open menu"
              title="Menu"
            >
              <Menu size={16} strokeWidth={2.2} />
            </button>

            <div className="am-chrome-brand" aria-label="Accounts Desk">
              <Users size={12} strokeWidth={2.3} aria-hidden />
              <span>Accounts Desk</span>
            </div>

            <div className="am-chrome-stats" aria-label="User summary">
              <span className="am-chrome-stat">
                <em>{totalUsers}</em> users
              </span>
              <span className="am-chrome-stat am-chrome-stat-live">
                <em>{activeCount}</em> active
              </span>
              {bannedCount > 0 ? (
                <span className="am-chrome-stat am-chrome-stat-warn">
                  <em>{bannedCount}</em> banned
                </span>
              ) : null}
            </div>
          </div>

          <div className="am-chrome-trail">
            <label className="am-chrome-search">
              <Search size={14} aria-hidden style={{ color: "rgba(255,255,255,0.4)", flexShrink: 0 }} />
              <input
                type="search"
                placeholder="Invite code, email, name…"
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                aria-label="Search users"
              />
              {search ? (
                <button
                  type="button"
                  onClick={() => onSearchChange("")}
                  aria-label="Clear search"
                  className="am-chrome-search-clear"
                >
                  <X size={12} />
                </button>
              ) : null}
            </label>

            <button
              type="button"
              className={`am-chrome-btn am-chrome-btn-filters lg:hidden ${
                filtersOpen || activeFilterCount ? "am-chrome-btn-on" : ""
              }`}
              onClick={onFiltersToggle}
              aria-label="Filters"
              title="Filters"
            >
              <SlidersHorizontal size={15} strokeWidth={2.2} />
              {activeFilterCount ? <span className="am-chrome-badge">{activeFilterCount}</span> : null}
            </button>

            <button
              type="button"
              className="am-chrome-btn"
              onClick={onRefresh}
              disabled={loading}
              aria-label="Refresh users"
              title="Refresh"
            >
              {loading ? <Loader2 size={15} className="am-spin" /> : <RefreshCw size={15} />}
            </button>
          </div>
        </div>
      </header>
      <div className="am-chrome-spacer" aria-hidden />
    </>
  );
}
